export default {
    'logout': 'Вы вышли из системы',
    'login': 'Для начало войдите систему',
    'auth/user-not-found': 'Пользователя с таким email не существует',
    'auth/wrong-password': 'Неверный пароль',
    'auth/email-already-in-use': 'Email уже занят'
}